export default "__VITE_ASSET__DrHETqvP__"